
export const TASK_LOAD_LIMITS = 50;
export const MAX_LOAD_TASK = TASK_LOAD_LIMITS * 2;
